/**
 * Polyfills and global error suppressions
 * This file must be imported FIRST in index.tsx
 */

// Suppress ResizeObserver loop errors (benign browser warning)
// This error occurs when ResizeObserver cannot deliver all observations in a single animation frame
// It's harmless and doesn't affect functionality

// Function to hide React error overlay if it shows ResizeObserver error
const hideResizeObserverOverlay = () => {
  const errorOverlays = document.querySelectorAll('iframe');
  errorOverlays.forEach((iframe) => {
    try {
      const iframeDoc = iframe.contentDocument || iframe.contentWindow?.document;
      if (iframeDoc?.body?.textContent?.includes('ResizeObserver loop')) {
        iframe.style.display = 'none';
        iframe.remove();
      }
    } catch (e) {
      // Cross-origin iframe, can't access
    }
  });
  
  // Also check for webpack dev server overlay
  const overlays = document.querySelectorAll('[id*="webpack"], [id*="overlay"], [class*="overlay"]');
  overlays.forEach((el) => {
    if (el.textContent?.includes('ResizeObserver loop')) {
      (el as HTMLElement).style.display = 'none';
    }
  });
};

// Watch for error overlay appearing
const observer = new MutationObserver((mutations) => {
  mutations.forEach(() => {
    hideResizeObserverOverlay();
  });
});

// Start observing once DOM is ready
if (document.body) {
  observer.observe(document.body, { childList: true, subtree: true });
} else {
  document.addEventListener('DOMContentLoaded', () => {
    observer.observe(document.body, { childList: true, subtree: true });
  });
}

// Error event handler
const errorHandler = (e: ErrorEvent) => {
  if (e.message?.includes('ResizeObserver loop') || 
      e.error?.message?.includes('ResizeObserver loop')) {
    e.stopImmediatePropagation();
    e.preventDefault();
    hideResizeObserverOverlay();
    return false;
  }
};

window.addEventListener('error', errorHandler, true);

// Also handle unhandled promise rejections
window.addEventListener('unhandledrejection', (e) => {
  if (e.reason?.message?.includes('ResizeObserver loop')) {
    e.preventDefault();
    e.stopImmediatePropagation();
  }
});

// Debounce ResizeObserver to prevent the error from occurring
const OriginalResizeObserver = window.ResizeObserver;
window.ResizeObserver = class ResizeObserver extends OriginalResizeObserver {
  constructor(callback: ResizeObserverCallback) {
    super((entries, observer) => {
      // Use requestAnimationFrame to batch observations
      window.requestAnimationFrame(() => {
        try {
          callback(entries, observer);
        } catch (e) {
          // Silently ignore ResizeObserver errors
        }
      });
    });
  }
};

export {};
